module.exports = __webpack_public_path__ + "img/vip_alipay.92de73d1.svg";